import {makeAutoObservable} from "mobx";
import ProductService from "../service/productsService";
export default class ProductsStore{
    constructor() {
        this._products = []
        this._loading = false
        makeAutoObservable(this)
    }

    async getAll(selectDate){
        try{
            this._loading = true
            const fetch = await ProductService.getAll(selectDate);
            this._products = fetch
            this._loading = false
            return fetch
        }catch (e) {
            this._loading = false
        }
    }
}



